import React, { useEffect, useState } from 'react'
import Wikipedia from '../../Services/Queries/wikipediamovie'

import Wikimovies from './Wikimovies'

function ImportMovies(props) {
  const {
    wikilink,
    editData,
    sendEditdata,
    sendBooleanValueChangeDone,
    scrapeMovie,
    contentType,
    setIsLoading,
    editMovieData,
    sendmovieData,
  } = props
  const [trueval, settrueval] = useState(false)
  const [movieInputUrl, setMovieUrl] = useState('')
  const [dataFromWiki, setdataFromWiki] = useState()
  function InputTextUrl(e) {
    setMovieUrl(e.target.value)
  }

  useEffect(() => {
    if (wikilink) {
      setMovieUrl(wikilink)
    }
  }, [])

  const clickToSubmit = async () => {
    setIsLoading(true)
    const input = {
      movieWikiURL: movieInputUrl,
      mode: 'edit',
    }

    const data = await Wikipedia(input)

    setdataFromWiki(data)

    if (movieInputUrl.length >= 1) {
      settrueval(true)
    } else {
      settrueval(false)
    }

    setIsLoading(false)
  }

  return (
    <div style={{ width: '1200px' }}>
      <p>Enter Wikipedia URL</p>
      <input
        type='text'
        value={movieInputUrl}
        onChange={event => InputTextUrl(event)}
        placeholder=' please enter wikipedia URL'
      />
      <button onClick={() => clickToSubmit()}>
        {scrapeMovie ? `Scrape ${contentType}` : 'Recheck'}
      </button>
      <div>
        {trueval ? (
          <Wikimovies
            sendEditdata={sendEditdata}
            editData={editData}
            trueval={trueval}
            contentType={contentType}
            dataFromWiki={dataFromWiki}
            wikilink={movieInputUrl}
            sendBooleanValueChangeofEdit={sendBooleanValueChangeDone}
            modeUrl={true}
            editMovieData={editMovieData}
            sendmovieData={sendmovieData}
          />
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default ImportMovies
